<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="{name: $i18n.locale + 'Settings' }">
            {{ $t('settings') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-bind:to="{name: $i18n.locale + 'ListRooms', params: { property: property.slug } }">
            {{  $t('rooms') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page" v-if="$route.params.room">{{ $t('room.edit') }}</li>
        <li class="breadcrumb-item active" aria-current="page" v-else>{{ $t('room.create') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            <span v-if="$route.params.room">
              {{ $t('room.edit') }}
            </span>
            <span v-else>{{ $t('room.create') }}</span>
          </h1>
          <p class="lead text-muted">
            <span v-if="$route.params.property">
              {{ $t('room.edit') }} {{ $route.params.room }}
            </span>
            <span v-else>{{ $t('room.create') }}</span>
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="roomForm">
                <div class="form-group">
                  <label for="room.property._id">{{ $t('label.property') }}</label>
                  <ValidationProvider name="property" vid="room.property" rules="required" v-slot="{ errors }">
                    <select class="form-control" v-model="room.property._id" :class="{ 'is-invalid': errors[0] }" disabled="true">
                      <option value="" disabled></option>
                      <option v-for="property in properties" v-bind:value="property._id">{{property.name}}</option>
                    </select>
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label>{{$t('label.name')}}</label>
                  <ValidationProvider name="name" v-slot="{ errors }" rules="required">
                    <input class="form-control" v-model="room.name" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label>{{$t('label.quantity')}}</label>
                  <ValidationProvider name="quantity" v-slot="{ errors }" rules="required">
                    <select class="form-control" v-model="room.quantity" :class="{ 'is-invalid': errors[0] }">
                      <option value="" disabled></option>
                      <option v-for="(key, index) in 10" v-bind:value="index + 1">{{index + 1}}</option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label>{{$t('label.beds')}}</label>
                  <ValidationProvider name="number of beds" v-slot="{ errors }" rules="required">
                    <select class="form-control" v-model="room.maxGuests" :class="{ 'is-invalid': errors[0] }">
                      <option value="" disabled></option>
                      <option v-for="(key, index) in 10" v-bind:value="index + 1">{{index + 1}}</option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group" v-for="(unit, index) in room.units">
                  <label>{{$t('label.unit.name')}} {{index + 1}}</label>

                  <ValidationProvider name="number of beds" v-slot="{ errors }" rules="required">
                    <input class="form-control" v-model="room.units[index].name" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>

                </div>


                <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                  <button v-b-modal.confirmDeleteModal type="button" name="delete" class="btn btn-danger flex-grow-1" v-bind:class="{'disabled': !room._id}">{{ $t('delete') }}</button>
                  <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">{{ $t('save') }}</button>
                </div>

              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <ConfirmDelete ref="confirmDelete" v-bind.sync="{type: 'room', delete: deleteRoom}"></ConfirmDelete>
  </div>
</template>

<script>
import ConfirmDelete from '../partials/modals/ConfirmDelete.vue';

export default {
  name: 'CreateRoom',
  props: ['socket'],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }
    });
  },
  components: {
    ConfirmDelete
  },
  data: () => ({
    from: null,
    room: {
      property:{},
      units: []
    },
    property: {},
    properties: []
  }),
  created(){
    this.properties = this.$store.state.host.properties
    if(this.$route.params.property){
      this.property = this.properties.find(p => p.slug == this.$route.params.property) || {};
      this.room.property._id = this.property._id
    }else if(this.$route.params.room){
      this.fetchRoom();
    }
  },
  watch: {
    'room.quantity': function(newVal, oldVal){
      let units = [];
      for(let i = 0; i < newVal; i++) units.push({});
      this.room.units = this.room.units.concat(units).slice(0, newVal)
    }
  },
  methods: {
    fetchRoom: function(){
      fetch(process.env.VUE_APP_API + '/rooms/' + this.$route.params.room, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        this.room = response;
        this.property = this.properties.find(p => p._id == this.room.property._id);
      })
    },
    submit: function(){

      let url = this.$route.params.room ? '/rooms/' + this.$route.params.room : '/rooms';
      let action = this.$route.params.room ? 'PUT' : 'POST';

      console.log(url);
      console.log(action);

      return fetch( process.env.VUE_APP_API + url, {
        method : action,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          room: this.room,
          socket: {
            id: this.socket.id
          }
        })
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          this.$router.push({name: this.$i18n.locale + 'ListRooms', params: { property: this.property.slug }});
        }else{
          console.log(response.error);
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    },
    deleteRoom: function(){
      //if(!confirm("Are you sure you want to delete guest?")) return;
      return fetch(process.env.VUE_APP_API + '/rooms/' + this.$route.params.room, {
        method: 'delete',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          this.$parent.messages.push({
            type: "alert",
            status: 'success',
            message: 'Room Deleted Successfully',
            time: Date.now()
          })
          this.$router.push({'name': this.$i18n.locale + 'ListRooms', 'property': this.property.slug});
        }else{
          this.$parent.messages.push({
            type: "alert",
            status: 'danger',
            message: response.error,
            time: Date.now()
          })
        }
      });
    }
  }
}
</script>

<i18n>
{
  "en": {
  "settings": "Settings",
  "properties": "Properties",
  "rooms": "Rooms",
    "room": {
      "create": "Create Room",
      "edit": "Edit Room"
    },
    "label": {
      "name": "Name",
      "quantity": "Number of units",
      "unit": {
        "name": "Name of unit no."
      },
      "beds": "Number of guests"
    },
    "save": "Save Room",
    "delete": "Delete Room"
  },
  "sl": {
    "settings": "Nastavitve",
    "properties": "Nastanitve",
    "rooms": "Sobe",
    "room": {
      "create": "Ustvari sobo",
      "edit": "Uredi sobo"
    },
    "label": {
      "property": "Nastanitev",
      "name": "Name",
      "quantity": "Število enot",
      "unit": {
        "name": "Naziv enote št."
      },
      "beds": "Število ležišč"
    },
    "save": "Shrani sobo",
    "delete": "Pobriši sobo"
  }
}
</i18n>
